import React from 'react';
import { YoutubeIcon, Music2Icon } from 'lucide-react';
export type Platform = 'youtube' | 'spotify' | 'apple-podcasts';
interface PlatformSwitcherProps {
  currentPlatform: Platform;
  onChange: (platform: Platform) => void;
}
export const PlatformSwitcher = ({
  currentPlatform,
  onChange
}: PlatformSwitcherProps) => {
  return <div className="flex justify-center mb-6" data-id="element-159">
      <div className="inline-flex bg-[#272727] p-1 rounded-full" data-id="element-160">
        <button onClick={() => onChange('youtube')} className={`flex items-center px-4 py-2 rounded-full text-sm transition-colors ${currentPlatform === 'youtube' ? 'bg-red-600 text-white' : 'text-gray-300 hover:text-white'}`} data-id="element-161">
          <YoutubeIcon size={18} className="mr-2" data-id="element-162" />
          YouTube
        </button>
        <button onClick={() => onChange('spotify')} className={`flex items-center px-4 py-2 rounded-full text-sm transition-colors ${currentPlatform === 'spotify' ? 'bg-green-600 text-white' : 'text-gray-300 hover:text-white'}`} data-id="element-163">
          <Music2Icon size={18} className="mr-2" data-id="element-164" />
          Spotify
        </button>
        <button onClick={() => onChange('apple-podcasts')} className={`flex items-center px-4 py-2 rounded-full text-sm transition-colors ${currentPlatform === 'apple-podcasts' ? 'bg-purple-600 text-white' : 'text-gray-300 hover:text-white'}`} data-id="element-165">
          <div size={18} className="mr-2" data-id="element-166" />
          Apple Podcasts
        </button>
      </div>
    </div>;
};